var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-center align-center"},[_c('AppLinks'),_c('a',{staticClass:"link-item",attrs:{"href":"https://help.selflane.com","target":"_blank"}},[_vm._v("Help Center")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }